// import { voices, sectionMeta } from "../data/Knowledge";
// import KnowledgeSection from "../KnowledgeCenter/KnowledgeSection";

// /* AssochamVoice.jsx
//    Listing page for Assocham's advocacy voice & policy memoranda.
//    Image banner + title hero; clickable banner cards open the
//    detail overview + download page (handled by the parent router). */
// export default function AssochamVoice({ onOpen }) {
//   return (
//     <KnowledgeSection
//       section={sectionMeta.voices}
//       items={voices}
//       onOpen={onOpen}
//     />
//   );
// }




// new code 




import { useNavigate } from "react-router-dom";
import { voices, sectionMeta } from "../data/Knowledge";
import KnowledgeSection from "../KnowledgeCenter/KnowledgeSection";

export default function AssochamVoice() {
  const navigate = useNavigate();

  return (
    <KnowledgeSection
      section={sectionMeta.voices}
      items={voices}
      onOpen={(item) => navigate(`/knowledge/assocham-voice/${item.id}`)}
    />
  );
}